const SECTORS = 'country-sectors';
const SEC_SECTORS = 'country-sectors.sector';
const CATEGORIES = 'country-sector-categories';
const SUBCATEGORIES = 'country-sector-subcategories';
const INDICATORS = 'country-sector-indicators';
const QUESTIONS = 'country-sector-questions';
const SEC_CATEGORIES = 'country-sector-categories.category';
const SEC_SUBCATEGORIES = 'country-sector-subcategories.subcategory';
const SEC_INDICATORS = 'country-sector-indicators.indicator';
const SEC_QUESTIONS = 'country-sector-questions.question';
const SEC_ANSWERS = 'country-sector-questions.question.answers';
const COUNTRY_SECTOR_YEAR_DATA = 'country-sector-year-data';
const SEC_SPECIAL_INSTITUTIONS = 'country-sector-year-data.special-institutions';

/* Graph types */
const BUBBLES = 'bubble-graphs?include=country-sector.country,country-sector.sector&page[size]=1000';
const ARC = 'pl-graphs?include=country-sector-year-data.country-sector.country,country-sector-year-data.country-sector.sector&page[size]=1000';
const TABLE = 'direction-graphs?include=country-sector.country,country-sector.sector,direction-scores&page[size]=1000';

export { SECTORS, CATEGORIES, SUBCATEGORIES, INDICATORS, QUESTIONS, SEC_SECTORS, SEC_CATEGORIES, COUNTRY_SECTOR_YEAR_DATA,
  SEC_SUBCATEGORIES, SEC_INDICATORS, SEC_QUESTIONS, SEC_ANSWERS, BUBBLES, ARC, TABLE, SEC_SPECIAL_INSTITUTIONS };



// WEBPACK FOOTER //
// ./app/constants/apiQueries.js